// extracted by extract-css-chunks-webpack-plugin
module.exports = {"o-modal-sticky__header":"o-modal-sticky__header___2WdHn","o-modal-sticky__header--shadow":"o-modal-sticky__header--shadow___1B732"};